import ContactModalDirective from "./view/ContactModalDirective";
import ContactModalController from "./view/ContactModalController";

const ContactModalModule = angular
    .module("ContactModalModule", [])
    .controller("ContactModalController", ContactModalController)
    .directive("contactModal", ContactModalDirective);
export default ContactModalModule;
